export default {
    url: 'https://novamark-demo-api.hubblehox.ai'
}
